import React, { useContext } from "react";
import { NamedProperty, Stack, WarningMessage } from "sprint-common-web";

import { DeliveryType } from "../../../common/types/DeliveryType";
import { UserRole } from "../../../core/security/User";
import { UserContext } from "../../../core/security/UserProvider";

export interface AssetsWarningProps {
    items: AssetWithOriginator[];
}

export interface AssetWithOriginator {
    originator?: NamedProperty;
    deliveryType?: DeliveryType;
}

export const AssetsWarning: React.FC<AssetsWarningProps> = (props: AssetsWarningProps) => {
    const user = useContext(UserContext);

    const restrictedAssets = props.items.filter(
        (p) =>
            p.originator &&
            p.deliveryType &&
            p.deliveryType === DeliveryType.DeliveryBucket &&
            !user.originatorIds.includes(p.originator.id)
    );

    if (user.roles.includes(UserRole.Admin) || restrictedAssets.length === 0) return <></>;

    return (
        <Stack styles={{ root: { marginBottom: 20 } }}>
            <WarningMessage message="You are currently browsing assets that are associated with originator that you don't have access to. You won't be able to place orders for those assets. Please contact support team." />
        </Stack>
    );
};
